const ENERGY_LABEL_LEADS = {
  title: 'Energiekennzeichnung-Leads',
  description: 'Übersicht der Leads für die Energiekennzeichnung',
  searchPlaceholder: 'Leads durchsuchen …',
  emptyState: 'Keine Leads gefunden.',
  importButton: 'Excel importieren',
  importError: 'Die Datei konnte nicht importiert werden.',
  importEmpty: 'Die Datei enthielt keine Zeilen.',
  importSummary: '{imported} von {received} Zeilen importiert.',
  importRejected: 'Abgelehnte Zeilen:',
  importRow: 'Zeile {row}',
  importErrors: {
    required: '{field} fehlt',
    invalid: '{field} ist ungültig',
    // more precise than the generic wording, worth its own key
    organizationNumber_invalid: 'Die Organisationsnummer muss 9 Ziffern haben',
  },
  importFields: {
    contactPerson: 'Kontaktperson',
    organizationNumber: 'Organisationsnummer',
    contactEmail: 'E-Mail',
    contactPhone: 'Telefon',
    companyName: 'Firmenname',
  },
  assignToMe: 'Mir selbst zuweisen',
  assignToMeNeedsEnovaGuid:
    'Ihrem Benutzer fehlt die persönliche Enova-GUID, daher können Sie keine Leads übernehmen.',
  backToList: 'Zurück zu den Leads',
  unassigned: 'Nicht zugewiesen',
  loadError: 'Leads konnten nicht geladen werden.',
  assignError: 'Der Lead konnte nicht zugewiesen werden.',
  notFound: 'Lead nicht gefunden.',
  importNotImplemented: 'Der Excel-Import ist noch nicht implementiert.',
  commentSaveError: 'Die Notiz konnte nicht gespeichert werden.',
  commentSaved: 'Notiz gespeichert.',
  daysAgo: 'vor {count} Tagen',
  missingAddress: 'Adresse fehlt',
  deleteConfirmTitle: 'Lead löschen',
  deleteConfirmMessage:
    'Soll dieser Lead wirklich gelöscht werden? Das kann nicht rückgängig gemacht werden.',
  deleteError: 'Der Lead konnte nicht gelöscht werden.',
  archiveError: 'Der Lead konnte nicht archiviert werden.',
  blockError: 'Der Lead konnte nicht blockiert werden.',
  blockNotYours: 'Nur der zugewiesene Berater kann diesen Lead blockieren.',
  blockWrongStatus:
    'Ein Lead kann nur während der laufenden Begehung blockiert werden.',
  archiveConfirmTitle: 'Lead archivieren',
  archiveConfirmMessage:
    'Möchten Sie diesen Lead wirklich archivieren? Er wird als archiviert markiert und verlässt die offenen Fälle.',
  archiveNotAllowed: 'Ein abgeschlossener Lead kann nicht archiviert werden.',
  assignWrongStatus:
    'Ein Lead kann nur zugewiesen werden, solange sein Status Formular ausgefüllt, Berater zugewiesen, Blockiert oder Informationen fehlen ist.',
  actions: {
    archive: 'Archivieren',
    block: 'Blockieren',
    unblock: 'Blockierung aufheben',
  },
  lifecycle: {
    title: 'Lebenszyklus',
    steps: {
      imported: 'Lead importiert',
      created: 'Angelegt — Formular an Kunden gesendet',
      formCompleted: 'Kunde fertig — bereit für Berater',
      inspectionStarted: 'Berater zugewiesen',
      inspectionCompleted: 'Berater fertig',
      completed: 'Energieausweis ausgestellt',
    },
  },
  building: {
    title: 'Gebäude',
    buildingNumber: 'Gebäudenummer',
    buildingType: 'Gebäudetyp',
    none: 'Dem Lead ist noch kein Gebäude zugeordnet.',
    open: 'Gebäude öffnen',
  },
  energyLabel: {
    title: 'Energieausweis',
    grade: 'Energieklasse',
    issued: 'Ausgestellt',
    openCertificate: 'Ausweis öffnen',
    complete: 'Lead abschließen',
    completeHelp:
      'Setzt den Lead auf abgeschlossen und sendet den Energieausweis per E-Mail an die Kontaktperson',
    completeError: 'Der Lead konnte nicht abgeschlossen werden.',
  },
  inspection: {
    title: 'Begehung',
    name: 'Name',
    date: 'Begehungsdatum',
    readSubmitted: 'Eingereichte Daten lesen',
    open: 'Begehung öffnen',
    create: 'Gebäudebegehung erstellen',
    createAgain: 'Neue Gebäudebegehung erstellen',
    noLead: 'Der Lead konnte nicht geladen werden.',
    fixErrorsFirst:
      'Beheben Sie zuerst die {count} Fehler in den Prüfungen oben.',
    createHint:
      'Die Begehung wird aus dem Formular oben erstellt, mit Standardwerten, wo der Kunde nichts angegeben hat.',
    created: 'Die Gebäudebegehung wurde erstellt.',
    noBuilding: 'Verknüpfen Sie zuerst ein Gebäude mit dem Lead.',
    noSubmission:
      'Mit dem Lead ist noch kein eingereichtes Formular verknüpft.',
    createError: 'Die Gebäudebegehung konnte nicht erstellt werden.',
    exists: 'Für diesen Lead wurde gerade eine Gebäudebegehung erstellt.',
    filledCount: '{count} Werte wurden mit Standardwerten ausgefüllt.',
  },
  filters: {
    allOpen: 'Alle offenen',
    waitingCustomer: 'Wartet auf Kunden',
    readyForInspector: 'Bereit für Berater',
    mine: 'Meine Vorgänge',
    completed: 'Abgeschlossen',
    stopped: 'Gestoppt',
    archived: 'Archiviert',
  },
  columns: {
    contactPerson: 'Ansprechpartner',
    organizationNumber: 'Organisationsnummer',
    address: 'Adresse',
    status: 'Status',
    consultant: 'Berater',
    created: 'Erstellt',
    actions: 'Aktion',
  },
  reminder: {
    send: 'Erinnerung senden',
    sent: 'Erinnerung gesendet',
    help: 'Sendet den Formularlink mit derselben Frist erneut',
    noDeadline:
      'Dieser Lead hat noch keine Frist — senden Sie zuerst die erste Benachrichtigung',
    error: 'Die Erinnerung konnte nicht gesendet werden.',
  },
  status: {
    imported: 'Importiert',
    created: 'Erstellt',
    formCompleted: 'Formular ausgefüllt',
    inspectionStarted: 'Berater zugewiesen',
    inspectionCompleted: 'Begehung abgeschlossen',
    completed: 'Energieausweis ausgestellt',
    blocked: 'Blockiert',
    notEnoughInformation: 'Informationen fehlen',
    cancelled: 'Archiviert',
    unknown: 'Unbekannt',
  },
  detail: {
    companyName: 'Firmenname',
    internalComment: 'Interne Notiz',
    internalCommentPlaceholder: 'Nur für uns sichtbar, nie für den Kunden',
    contactSection: 'Kontaktdaten',
    contactPerson: 'Ansprechpartner',
    phone: 'Telefon',
    email: 'E-Mail',
    companySection: 'Unternehmen',
    organizationNumber: 'Organisationsnummer',
    streetName: 'Straße',
    houseNumber: 'Hausnummer',
    houseLetter: 'Buchstabe',
    postalCode: 'Postleitzahl',
    city: 'Ort',
    mpidsSection: 'Messpunkt-IDs',
    noMpids: 'Keine Messpunkt-IDs hinterlegt',
    status: 'Status',
    formSection: 'Kundenformular',
    formLink: 'Link für den Kunden',
    copyLink: 'Link kopieren',
    linkCopied: 'Link kopiert.',
    formStatus: 'Formularstatus',
    formNotStarted: 'Noch nicht geöffnet',
    formDraft: 'In Bearbeitung',
    formSubmitted: 'Eingereicht',
  },
};

export default ENERGY_LABEL_LEADS;
